module.exports = __webpack_public_path__ + "img/00036.d6c13c37.webp";